class DataLayer {

	constructor() {
		if(isMobile.mobile) {
			this.device = 'mobile';
		} else if(isMobile.tablet) {
			this.device = 'tablet';
		} else {
			this.device = 'desktop';
		}

		this.pushDatalayerLoaded();
	}

	pushDatalayerLoaded() {
		let data;
		let device = this.device;

		$("[data-page]").each(function() {
			data = $(this).data("page");
			data.env_channel = device;
			data.event = "datalayer-loaded";
			data.language = "fr";
			dataLayer.push(data);
		});
	}

}